export default (value, enums) =>
  enums && enums.length && (enums.find(item => item.value == value) || {}).label || '其他';



// WEBPACK FOOTER //
// ./src/filters/enums/index.js